import { getAccessTokenFromCookie } from "../util/authentication";
import {
  OVERTIME_SERVICE_API_ADD_OT_EVENT,
  OVERTIME_SERVICE_API_GET_VOLUNTARY_OT_LIST,
  OVERTIME_SERVICE_API_OT_EVENT_ELIGIBILITY,
} from "../util/overtime/constants";

export const isOvertimeEventEligible = async (eid, station, date) => {
  const apiEndpoint =
    process.env.REACT_APP_OVERTIME_API +
    OVERTIME_SERVICE_API_OT_EVENT_ELIGIBILITY +
    "/" +
    eid +
    "/" +
    station +
    "/" +
    date;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  return response;
};

export const addOvertimeEvent = async (event) => {
  const apiEndpoint = process.env.REACT_APP_OVERTIME_API + OVERTIME_SERVICE_API_ADD_OT_EVENT;

  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: JSON.stringify(event),
  });
  if (!response.ok) {
    throw Error(`POST ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};

export const getVoluntaryOTList = async (date, station, workgroup) => {
  const apiEndpoint =
    process.env.REACT_APP_OVERTIME_API +
    OVERTIME_SERVICE_API_GET_VOLUNTARY_OT_LIST +
    "/" +
    date +
    "/" +
    station +
    "/" +
    workgroup;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`POST ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};
